import type { EmailKeyUserRow, ProblemFilter } from './types';

export function getProblemKind(row: EmailKeyUserRow): ProblemFilter | null {
  if (row.deleted) {
    return 'deleted';
  }
  if (row.authDisabled && !row.deleted) {
    return 'auth-disabled-without-deleted';
  }
  if (row.invitedNotSignedIn) {
    return 'invited-not-signed-in';
  }
  if (row.fallbackLegacy) {
    return 'fallback';
  }
  return 'existing';
}

export function matchesProblemFilter(row: EmailKeyUserRow, filter: ProblemFilter): boolean {
  if (filter === 'all') {
    return true;
  }
  return getProblemKind(row) === filter;
}

/** Deleted rows are omitted from the list API unless this filter is selected. */
export function includeDeletedForProblemFilter(filter: ProblemFilter): boolean {
  return filter === 'deleted';
}

/** Per-row Fold/Migrate is only for leftover legacy role trees, never deleted emails. */
export function rowNeedsMigration(row: Pick<EmailKeyUserRow, 'fallbackLegacy' | 'deleted'>): boolean {
  return row.fallbackLegacy === true && row.deleted !== true;
}
